import enums from "./../enums";

const coupons = (
	state = {
		loading: false,
		paymentMethods: [],
		missingDocument: "",
		odendibilTypes: [],
		hasUnapprovedDocument: false,
	},
	{ type, payload }
) => {
	switch (type) {
		case enums.WITHDRAW_LOADING:
			return { ...state, loading: payload };
		case enums.UNAPPROVED_DOCUMENT:
			return { ...state, hasUnapprovedDocument: payload };
		case enums.WITHDRAW_PAYMENT_METHODS:
			return { ...state, paymentMethods: payload };
		case enums.ODENDIBIL_TYPES:
			return { ...state, odendibilTypes: payload };
		case enums.MISSING_DOCUMENT:
			return { ...state, missingDocument: payload };
		default:
			return { ...state };
	}
};

export default coupons;
